<template>
  <v-dialog v-model="dialogShow" persistent max-width="540">
    <v-card>
      <v-card-title class="tipsDialog-title">
        温馨提示
        <v-spacer></v-spacer>
        <p @click="hideDialog" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="padding:33px 40px 44px 50px">
        <p class="tipsDialog-mainAreaNoIcon-text">欢迎您，吉林一号·共生地球的探索者!</p>
        <p style="margin-top:22px;" class="tipsDialog-mainAreaNoIcon-text">吉林一号·共生地球为探索者们带来了丰富且精美的遥感影像与个性化的地球创作平台</p>
        <p style="margin-top:22px;" class="tipsDialog-mainAreaNoIcon-text">点击开始观看，一起走近吉林一号·共生地球新体验</p>

        <div style="margin-top:46px;" class="tipsDialog-mainArea-btnLine">
          <v-btn @click="hideDialog" width="100" height="35" color="#F5F5F5">取消</v-btn>
          <v-btn @click="playGuideVideo" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">开始观看</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "FirstGuideDialog",
  props:["dialogShow"],
  methods:{
    playGuideVideo(){
      this.$emit("playFirstGuideVideo")
      this.$emit("hideFirstGuideDialog")
    },
    //隐藏弹窗
    hideDialog(){
      this.$emit("hideFirstGuideDialog")
    }
  }


}
</script>

<style scoped>

</style>